import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // Set background video on window resize.
    window.addEventListener("resize", this.updateBackgroundVideo);
    // Set background video on initial load.
    this.updateBackgroundVideo();
  }

  // Set <video>'s src attribute for background video.
  updateBackgroundVideo = () => {
    // DOM Element.
    const bgEl = this.element.querySelector(".bg-video");

    // Do nothing if there's no video.
    if (!bgEl) return;

    // Sources passed from WP into the data attributes.
    const desktopSrc = bgEl.dataset.desktopSrc;
    const mobileSrc = bgEl.dataset.mobileSrc || desktopSrc;

    // Set the src attribute to whichever data attribute is appropriate.
    bgEl.src = window.innerWidth < 700 ? mobileSrc : desktopSrc;
  };
}
